export const DefaultHeaderStyles = {
  container: 'w-full flex flex-row h-24 sm:h-28',
  banner: 'w-full object-cover',
  bannerLogo: 'w-44 absolute top-8 left-8 sm:w-52 sm:top-10'
}
